/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IPriceVisualizationViewProps } from './price-visualization';

export default (props: IPriceVisualizationViewProps) => {
    return <div className='row'></div>;
};
